import { render, staticRenderFns } from "./SmartChronicDisease.vue?vue&type=template&id=5e14dc00&"
import script from "./SmartChronicDisease.vue?vue&type=script&lang=js&"
export * from "./SmartChronicDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports